import script from "./GeolocationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeolocationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./GeolocationsPage.vue?vue&type=style&index=0&id=53ebfdbf&lang=scss"

const __exports__ = script;

export default __exports__